export const debounceApiWithDelay = async (func, timeout = 100, timer) => {
  return async (...args) => {
   
    const delay = () =>
      new Promise((resolve, reject) => {
        timer.data = setTimeout(async () => {
          let data = await func.apply(this, args);
          resolve(data);
        }, timeout);
      });
    if (timer.data) {
      clearTimeout(timer.data);
      timer.data = null;
    }
    return delay();
  };
};